import { buildWidgetAssetUrl } from "../../../widgetAssetUrl";

type ChannelIconProps = {
  src: string;
  alt: string;
};

export const ChannelIcon = ({ src, alt }: ChannelIconProps) => {
  return <img src={buildWidgetAssetUrl(src)} alt={alt} />;
};
